/*
 * @Author: HS
 * @Date: 2022-02-09 15:44:18
 * @LastEditors: DQL
 * @LastEditTime: 2022-06-25 10:15:40
 * @Description: file content
 */
const xjglRoutes = {
  path: 'xjgl',
  name: 'xjgl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'xjsqAdd/:processInsId',
      name: 'xjsqAdd',
      component: () =>
        import(
          /* webpackChunkName: "xjsq" */ '@/features/attendance/qxjgl/xjgl/xjsq.vue'
        ),
      meta: {
        navtabTitle: '销假申请',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'xjsq/:processInsId',
      name: 'xjsq',
      component: () =>
        import(
          /* webpackChunkName: "xjsq" */ '@/features/attendance/qxjgl/xjgl/xjsq.vue'
        ),
      meta: {
        navtabTitle: '销假申请',
        isCache: true,
        ignoreDiff: ['openFrom'],
        menuElements: []
      }
    },
    {
      path: 'xjsqBack/:processInsId/:condition',
      name: 'xjsqBack',
      component: () =>
        import(
          /* webpackChunkName: "xjsqBack" */ '@/features/attendance/qxjgl/xjgl/xjsq.vue'
        ),
      meta: {
        navtabTitle: '销假申请',
        isCache: true,
        ignoreDiff: ['openFrom'],
        menuElements: []
      }
    },
    {
      path: 'xjsqSp/:processInsId/:taskId',
      name: 'xjsqSp',
      component: () =>
        import(
          /* webpackChunkName: "xjsqSp" */ '@/features/attendance/qxjgl/xjgl/xjsqSp.vue'
        ),
      meta: {
        navtabTitle: '销假申请审批',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'xjsqSpResult/:processInsId/:taskId',
      name: 'xjsqSpResult',
      component: () =>
        import(
          /* webpackChunkName: "xjsqSpResult" */ '@/features/attendance/qxjgl/xjgl/xjsqSp.vue'
        ),
      meta: {
        navtabTitle: '销假申请审批',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'xjdmx/:processInsId/:taskId?',
      name: 'xjdmx',
      component: () =>
        import(
          /* webpackChunkName: "xjdmx" */ '@/features/attendance/qxjgl/xjgl/xjdmx.vue'
        ),
      meta: {
        navtabTitle: '销假申请明细',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};
export default xjglRoutes;
